/**
 * include bottom menu content to body dom
 * @requires  phoneBindingDrawer.mod  jQuery  Vue
 * need stylesheet: common_component.css, css/bottom_menu.css
 */
import template from '../../html/content_module/phoneBindingDrawer.mod';
import '../../css/content_module/phoneBindingDrawer.css';

import Link from '../../common/prefixName';
import externalApp from '../../data/externalApp';
var apiBaseUri = Link.prefix.realmName;

// util
import timerManager from "../../lib/platformApi/timerManager";
import storageManager from "../../lib/platformApi/storageManager";

/* module config */

let config = {
    apiConfig : {
    },

    verifyCodeSendDelay : 60
};

/* end module config */

$(document.body).append(template);

let control = new Vue({
    el: '#phoneBindingDrawer',
    data(){
        return {
            visible: false,
            phone : '',
            verifyCode : '',
            phoneInputRow : {
                active : false
            },
            verifyCodeInputRow : {
                active : false
            },
            verifyCodeSeconds : 0,
            countDownTimer : null,
            externalApp : externalApp,
            isBindedPhone : false,
            agreeServiceProtocol : true,
            onBindSuccess : null
        }
    },
    methods: {
        getVerifyCode() {

            const me = this;

            if (!this.phone)
            {
                return;
            }

            // check timer
            if (this.countDownTimer)
            {
                app.showMessageBox('验证码' + config.verifyCodeSendDelay + '秒内有效');
                return;
            }

            let sendVerifyCodeApi = {
                type: 'post',
                url: apiBaseUri + '/login/sendMsgVerifyCode',
                data : {
                    phone : this.phone
                },
                success : function(result) {
                    let errorCode = result.errorCode || 0;
                    if (errorCode)
                    {
                        app.showMessageBox(result.msg);
                        return;
                    }

                    app.showMessageBox('发送成功，请查收。');

                    me.verifyCodeSeconds = config.verifyCodeSendDelay;
                    me.countDownTimer = timerManager.setInterval(() => {
                        me.verifyCodeSeconds--;

                        if (me.verifyCodeSeconds == 0)
                        {
                            timerManager.clearInterval(me.countDownTimer);
                            me.countDownTimer = null;
                        }
                    }, 1 * 1000);
                },
                error : app.generalAjaxError
            };

            $.ajax(sendVerifyCodeApi);

        },
        onChangeVerifyCode() {

            if (this.verifyCode.length > 6)
            {
                this.verifyCode = this.verifyCode.substr(0, 6);
            }
        },
        bindPhone() {

            const me = this;

            if (!this.phone)
            {
                return;
            }

            let phone = this.phone;
            let verifyCode = this.verifyCode;

            if (verifyCode.length > 8)
            {
                app.showMessageBox('验证码过长，请检查。');
                return;
            }

            let verifyPhoneCodeApi = {
                type: 'post',
                url: apiBaseUri + '/login/msgVerifyCode',
                data : {
                    phone   : phone,
                    code    : verifyCode
                },
                success : function(result) {
                    let errorCode = result.errorCode || 0;
                    if (errorCode)
                    {
                        app.showMessageBox(result.msg);
                        return;
                    }

                    let bindPhoneApi = {
                        type: 'post',
                        url: apiBaseUri + 'login/bindPhone',
                        data : {
                            phone : phone,
                            code : verifyCode
                        },
                        success : function(result) {
                            let errorCode = result.errorCode || 0;
                            if (errorCode)
                            {
                                app.showMessageBox(result.msg);
                                return;
                            }

                            me.isBindedPhone = true;

                            storageManager.setItem('bindPhoneTime', moment().format('YYYY-MM-DDTHH:mm:ss'));

                            // this.$emit('bindSuccess');
                            me.onBindSuccess ? me.onBindSuccess() : null;
                        },
                        error : app.generalAjaxError
                    };

                    $.ajax(bindPhoneApi);
                },
                error : app.generalAjaxError
            };
            $.ajax(verifyPhoneCodeApi);
        }
    },
    mounted : function (){

        const me = this;

        Link.verifyLoin(function (user) {

            if (user)
            {
                $.ajax({
                    type: 'post',
                    url: apiBaseUri + 'login/isBindPhone',
                    success : function(result) {
                        me.isBindedPhone = result.data;
                    }
                });
            }

        });


    }
});
export default control;



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/phoneBindingDrawer.js
 **/